const TEXT_STRING = {
  COMMON: {
    NO_DATA: 'データなし',
    MY_PAGE: 'マイページ',
    INFO: '基本情報',
    AGE: '歳',
    CANCEL: 'キャンセル',
    LOGIN: 'ログイン',
    REGISTER: '会員登録は',
    YEN: '円',
    POINT_UNIT: 'T',
    PEOPLE: '人',
    REQUIRE: '必須',
    MULTIPLE_CHOICE: '※複数可',
    MALE: '男性',
    UNKWOWN_MALE: '男性ユーザー',
    FEMALE: '女性',
    SET: 'セット',
    PERSON: '名',
    COMPLETION: '完了',
    HOUR: '時',
    NO: 'いいえ',
    YES: 'はい',
    YEN_HOUR: '円/時',
    RANK: 'ランク',
    TECO_GIRL: 'テコガール',
    LIST_TECO_GIRL: 'ゲーム一覧',
    GAME: 'ゲーム',
    UNDO: '取り消し',
    CONFIRM_DELETE: 'カードを削除しますか。',
    CONFIRM_MESSAGE: '宜しいでしょうか。',
    SOMETHING_WENT_WRONG: '何か問題が発生しました。',
    KEEP: '保存',
    PROFILE: 'プロフィール',
    GO_TO_PROFILE: 'プロフィールへ',
    EMAIL_NOT_VALID: '無効メールです。',
    CONTINUE: '続ける',
    SETTING: '設定',
    DISCOUNT_COUPON: '割引クーポン',
    DISCOUNT_FOR_ONE: '個テコ(1対1)3万円以上のゲーム代注文時',
    DISCOUNT_FOR_MULTIPLE: '団体注文時のゲーム代割引',
    SOMEONE_WANT_CONTACT: '個別のメッセージができます',
    GAME_FEE: 'ゲーム代を',
    DISCOUNT_NOTE: '以上注文されたら',
    DISCOUNT: '割引',
    RECENT_TWEETS: '最近のつぶやき',
    RECEIVED_MESSAGE: 'さんからメッセージが届きました！',
    MEETING: '合流中',
    NEXT: '次へ',
    MENU: 'MENU',
    SELECT: '選択する',
    NOT_FOUND_GIRL: 'テコガールIDが見つかりません。',
    PRICE_SINGLE_ORDER: '20,000',
    AMOUNT: '金額',
    TYPING: '誰かが入力しています',
    MGM_STAFF: '運営スタッフに問い合わせ',
    QUIT: '退出',
    SUCCESS: '成功',
    BACK: '后退',
    MESSAGE_REMOVED_CHANNEL: 'グループチャットから削除されました！',
    QUANTITY: '個数',
    INDIVUAL: '個',
    INQUIRY: '問い合わせ',
    CLOSE: '閉じる',
    RESET: 'リセット',
    ONE_MAN: '万円',
    PUBLIC: '公開',
    PENDING: '承認待ち...',
    APPROVED: '承認済',
    ONE_NIGHT: '1泊',
    START_DATE: '開始日',
    END_DATE: '終了日',
    PRICE_RANGE: '$min円 ～ $max円',
    UNUSED: '未使用',
    COUNT: '回',
    AND: 'と',
    UNREGISTERED: '未登録',
    NAVIGATE_TO_REGISTER_SCREEN: '会員登録はこちら',
    QUOTE: '「$value」',
    RETURN: '戻る',
    PAYMENT_HERE: '決済ページはこちら',
    WARNING: '警告',
    CHOOSE: '選ぶ',
    CREDIT_CARD_REGISTRATION: 'クレジットカード登録',
    TOTAL_STAMPS: '投げ銭スタンプ総額',
    TOTAL_POINTS: 'teco資産購入金額',
    COPY: 'コピー',
    COPY_SUCCESS: 'リンクをコピーしました。',
    OTHER: 'それ以外',
    OTHER_WITHOUT_VISA: 'Amex',
    MAINTENANCE: '※メンテナンス中',
    SHOW_ALL: 'すべて表示',
    PAYMENT_MONEY: '現金払い',
    PAYMENT_POINT: 'teco資産払い',
    PAYMENT_CARD: 'カード払い',
    OTHERS: 'その他',
    LOGIN_HINT: 'ログインできない場合は',
    EDITED: '編集済み',
  },
  NAVIGATION: {
    SEARCH: '探す',
    HOME: 'つぶやき',
    CALL: '今すぐ呼ぶ',
    MESSAGE: 'メッセージ',
  },
  SEARCH_PAGE: {
    SET_CONDITIONS: '検索条件を設定する',
    SEARCH: '検索',
    REFINE: '絞り込み検索',
    STYLES: 'スタイル',
    LINEAGE: '系統',
    ENJOY_METHOD: '楽しみ方',
    GAME_PLAY: '遊べること',
    SCHEDULES: '本日出勤',
    TODAY: '本日',
    PRODUCT_SHELF: '商品',
    JOB_SHELF: '求人',
    JOB_GROUP_BRAND: 'ブランド一覧',
    JOB_GROUP_STAFF: 'スタッフ求人',
    JOB_GROUP_COMMUNITY: 'コミュニティ',
    SCHEDULES_TAB: 'スケジュール',
    LIST_EMPLOYEES: '在籍一覧',
    LIST_DISCOUNT: '割引一覧',
    PICK_UP: 'サービスが良いテコガール',
    YARIKANO_GIRLFRIEND: 'コスパいい団体は系列のヤリカノ',
    YARIKANO_CARD_LINK_ARIA_LABEL:
      'ヤリカノカノジョ {{rank}}位 プロフィールを見る',
    INDIVIDUAL_RECOMMEND_LIST: 'オススメ',
    RANKING: '全国\nランキング',
    RATING: '評価',
    DISCOUNT_MINIMUM: '以上のゲーム代注文時に',
    SEARCH_NOTE: 'テコガールの名やIDや自己紹介をフリーワードで検索できます',
    SEARCH_BY_KEYWORD: 'フリーワード検索',
    ENTER_KEYWORD: 'フリーワードを入力してください',
    TO_BE_CONFIRM: '要確認',
    GO_NOW: 'すぐ行けます',
    HOW_TO_PLAY: '遊び方の\n説明動画',
    GROUP_SERVICES: '系列サービス',
    FRANCHISE: 'フランチャイズ',
    MEETING: '合流中',
    PERIOD_TIME: '生理中',
    HOT_VIDEO: 'イカれた\nゲーム動画',
    SHELF_MODAL_OFFICIAL_SITE: '公式サイトへ →',
    SHELF_MODAL_COPY_URL: 'URLをコピー',
    SHELF_MODAL_COPY_URL_SUCCESS: 'URLをコピーしました。',
    SHELF_MODAL_SALARY_TABLE_TITLE: '給与の例',
  },
  CAST_PAGE: {
    SCHEDULES: '出勤時間',
    FOLLOW: 'フォロー',
    FOLLOWING: 'フォロー中',
    FRANCHISE: 'フランチャイズ',
    INTRO: '自己紹介',
    CHAT: 'メッセージする',
    CALL: '指名して呼ぶ',
    NAME: '名前',
    AGE_NUMBER: '年齢',
    HEIGHT: '身長',
    NOMINATION_FEE: '指名料',
    CM: 'cm',
    THREE_SIZES: '3サイズ',
    BUST_SHORT: 'B.',
    WAIST_SHORT: 'W.',
    HEIGHT_SHORT: 'H.',
    NUMBER_CUP: 'カップ数 ',
    CUP: 'カップ',
    PERIOD_MESSAGE: '生理中です',
    RANK: 'ランク',
    POINT: '評価',
    ABROADER: 'ABROADER',
    ACTIVITY_AREA: 'エリア',
    AFFILIATION_AREA: '所属エリア',
    WORK_AREA: '出勤エリア',
    OK: 'OK',
    NO: 'No',
    REQUIRE_LOGIN_FOR_GLAMOUR_IMAGE: 'ログインすると閲覧できます',
    RATING_BADGE:
      'お客様からもらった評価スタンプ(個テコ利用時にプレゼント可能)',
    DAILY_RANK: 'デイリーランキング$rank位',
  },
  APP_INFO: {
    TERMS_OF_SERVICE: '利用規約',
    PRIVACY_POLICY: 'プライバシーポリシー',
    SPECIAL_COMMERCIAL_LAW: '特定商取引法に基づく表記',
    ABOUT:
      '【完全版】エロいデート・ギャラ飲みができる「teco（テコ）」のご利用方法をご紹介！',
  },
  MY_PAGE: {
    ACCOUNT_INFO: 'アカウント情報',
    SALON_MEMBER: 'SALON会員',
    VIP_RANK_LABEL: '現在のランク',
    LIST_FOLLOWING: 'フォローしている女性一覧',
    PAYMENT_METHOD: 'お支払い方法',
    ORDER_HISTORY: '注文履歴',
    GACHA_TICKETS: 'ガチャで当たった券',
    LOGOUT: 'ログアウト',
    PREVIEW_IMAGE: 'プレビュー画像。',
    EMAIL_NOTI_SETTING: 'メール通知設定',
    EMAIL_RECEIVE: '受信するメールアドレス',
    GROUP_CHAT_MESSAGE: 'グループチャットのメッセージ',
    MESSAGE_FROM_STAFF: '運営スタッフのメッセージ',
    TECO_GIRL_MESSAGE: 'テコガールのメッセージ',
    CONFLUENCE: '合流',
    GAME_SELECTION: 'ゲームの選択',
    SMS_DELIVERY: 'SMS配信',
    OPEN_TUTORIAL: 'tecoをホーム画面へ追加し、push通知を受信できるようにする',
    NOTI_SETTING: '通知設定',
    JOIN_NOTI: '合流通知',
    FEMALE_MET: '合流した女性一覧',
    FEMALE_MET_TEXT: '過去に呼んだことのあるテコガール',
    ABOUT_APP: 'アプリに関して',
    LOVE_HOTELS: 'ラブホ一覧',
    HOW_TO_USE: 'ご利用方法',
    FAQ: 'よくある質問',
    ACCOUNT: 'アカウント',
    COMMUNICATION_GUIDE: 'コミュニケーションガイドライン',
    TERMS_OF_SERVICE: '利用規約',
    PRIVACY_POLICY: 'プライバシーポリシー',
    LEGAL_COMPLIANCE_POLICY: '法令遵守ポリシー',
    PROFILE_IMAGE_REVIEW: 'プロフィール画像の審査結果',
    BUY_POINTS: 'teco資産を購入する',
    BUY_POINTS_HISTORY: 'teco資産購入履歴',
    PURCHASED_PAID_TWEET: '購入した有料のつぶやき',
    SPECIAL_COMMERCIAL_LAW: '特商法',
    ABOUT: 'tecoとは',
    LINE_LINK: 'LINE連携',
    BIOGRAPHY_PLACEHOLDER: '自己紹介を設定するとここに表示されます',
  },
  GACHA_TICKETS: {
    LOADING: '券を確認しています',
    ERROR: '券を取得できませんでした',
    RETRY: '再試行',
    USABLE_COUNT: '使える券 $count 枚',
    USABLE: '使える券',
    UNIT: '枚',
    DISPLAYED_ONLY: '（表示分）',
    OVERFLOW: '表示しきれない券があります',
    EMPTY: 'ガチャで当たった券はありません',
    NO_USABLE: '使える券はありません',
    COUNT: '× $count 枚',
    NEAREST: 'いちばん近い期限',
    DETAILS: '期限を見る ›',
    CLOSE: '閉じる ‹',
    PAST: '使用済み・期限切れ',
    PAST_LIMIT: '過去は最大 50 枚まで表示',
    USED: '使用済み',
    EXPIRED: '期限切れ',
    EXPIRY: '期限',
    USED_AT: '使用日',
    SET_NAME: '個テコ 1 セット無料',
    UNKNOWN_GAME: 'ゲーム券（名称未設定）',
    GAME_TICKET: 'ゲーム券',
    SET_TICKET: 'セット券',
    EXPIRES_TODAY: '本日 $time まで',
    DAYS_LEFT: 'あと $count 日',
  },
  MALE_PAGE: {
    PROFILE_DETAIL: 'プロフィール詳細',
    PROFILE_INFO: 'プロフィール情報',
    EDIT_PROFILE: 'プロフィール編集',
    USING_TECO: 'tecoの利用',
    TOTAL_AMOUNT: '会計総額',
    NUM_OF_ORDERS: '注文回数',
    TOTAL_STAMP: 'スタンプ総額',
    COLLECTIONS: 'Profile image',
    PREVIEW: 'プレビュー',
    ANNUAL_INCOME: '年収',
    AVATAR: 'アバター画像',
    PROFILE_IMAGE: 'サブ画像',
    UTILIZATION_AMOUNT: '累計利用金額',
    TOTAL_USES: '累計利用回数',
    INTRO: '自己紹介',
    INTRO_URL_ERROR: '自己紹介にURLは入力できません',
    INTRO_MAX_LENGTH_ERROR: '自己紹介は140文字以内で入力してください',
  },
  PROFILE_RANK: {
    GUEST_RANK: 'ゲストランク',
    SALON_RANK: 'SALONランク',
    USAGE_30_DAY: '直近30日間の利用',
    USAGE_AMOUNT: '利用金額：$amount',
    USAGE_COUNT: ' 利用回数：$count回',
    GUEST_RANK_CONDITIONS: 'ゲストランクの条件',
    RANK_STAR_CONDITIONS:
      '星0個：利用回数0回\n星1個：利用金額5万円以上もしくは利用回数1回\n星2個：利用金額20万円以上もしくは利用回数2回\n星3個：利用金額50万円以上もしくは利用回数4回\n星4個：利用金額100万円以上もしくは利用回数8回\n星5個：利用金額200万円以上もしくは利用回数12回',
    RANK_NOTE:
      'ゲストランクを決定する期間は直近30日間。\n直近30日間で上記の条件を満たさなかった場合、ゲストランクが一つ下がります。',
    OVER_ONE_MAN: '$amount万円以上',
    LESS_ONE_MAN: '$amount万円未満',
  },
  FAQ: {
    QUESTION_1: '交通費はかかりますか？',
    ANSWER_1:
      '交通費はセット料金に含まれているためテコガールズにお支払いいただかなくて大丈夫です！',
    QUESTION_2: '男性何人で使ってもいいですか？',
    ANSWER_2:
      '男性1名で、男性複数人、女性より多め全然OKです！\nご利用者様が複数名の場合はテコガールは2名以上からの派遣となります！\nまたお客様1名の場合のみとテコガール1名との〝個teco〟も可能です✨',
    QUESTION_3: '場所は本当にどこでもいいんですか？',
    ANSWER_3:
      '自宅、ラブホ、ビジホ、個室、飲食店どこでもお届けします🚗。ただし公衆の面前はNG🙅‍♂️です',
    QUESTION_4: 'どこまでできるんですか？',
    ANSWER_4: 'さいっっっっこうにエロい飲み会とだけ…🤫💕言っておきます😆🍌',
    NOTE: '🟨当サービスではしょうもないぼったりくりは絶対許しておりませんのでご安心ください\n\n🟨生理中のテコガールは名前の横に🩸のマークがつくので参考にしてください\n\n🟨当サービスではお客様の秘密を厳守しております。著名人の方でも安心してご利用いただけます',
  },
  LOGIN: {
    WARNING_LOGIN: 'ログインしてください!',
    MESSAGE_LOGIN: 'これらの女の子と話すにはログインしてください',
    PHONE_NUMBER: '電話番号',
    REQUIRE: '必須',
    HERE: 'こちら',
    MESSAGE_REGISTER: '登録するために、以下の情報を入力してください',
    EXISTING_ACCOUNT_FOUND: '既存のアカウントが見つかりました',
    NICK_NAME: 'ニックネーム',
    PLACEHOLDER_PHONE: '03 1234 5678',
    PLACEHOLDER_NICK_NAME: 'ニックネームを入力してください。',
    EMAIL: 'メール',
    PLACEHOLDER_EMAIL: 'abc@email.com',
    GO_LOGIN: 'すでにアカウントをお持ちの方は',
    REGISTRATION: '登録',
    PLACE_HOLDER_NUMBER: '10',
  },
  NOT_FOUND: {
    ERROR: '404',
    TEXT: 'Page not found',
    MESSAGE: 'Sorry, we couldn’t find the page you’re looking for.',
    GO_BACK: 'Go back home',
  },
  FOLLOWING_PAGE: {
    LIST: 'フォロー一覧',
  },
  PRICE_LIST: {
    TITLE: 'どのようなシーンで\nご利用ですか？',
    MULTIPLE_SELECT: '※複数選択可',
    SCENE_LIST: [
      '接待',
      '1対1のデート',
      'パーティ',
      '飲み会だけ',
      '旅行に行く',
      'その他',
    ],
    PLAN_LIST_TITLE: '料金プラン',
    PLAN_LIST: [
      { name: '団体派遣', price: '¥20,000〜/1名〜' },
      { name: '個テコ', price: '¥20,000/1名' },
    ],
    PLAN_DETAIL_LIST: [
      {
        name: '団体派遣',
        description: 'お客様が複数名の場合、テコガールは最低2名から呼べます。',
        caution:
          '※"飲み会だけ"を選択の場合にはテコガール1名〜呼ぶことが可能となります。',
        price: '¥20,000〜',
        priceNotes: 'テコガール1名・1セット(60分)',
        girlCount: '2名〜',
        usageTime: '24時間',
        extension: '可能',
        addPrice: undefined,
        chipText: '人気',
      },
      {
        name: '個テコ',
        description: 'お客様が1人の場合、テコガール1名から呼べます。',
        price: '¥20,000〜',
        priceNotes: 'テコガール1名・1セット(60分)',
        girlCount: '1名',
        usageTime: '24時間',
        extension: '可能',
        addPrice: undefined,
        chipText: 'おすすめ',
      },
    ],
    GIRL_COUNT_HEAD: 'テコガール',
    USAGE_TIME_HEAD: '利用時間',
    EXTENSION_HEAD: '延長',
    ADD_PRICE_HEAD: '追加費用',
    MORE_PLAN: 'プラン詳細を見る',
  },
  CALL_WOMAN: {
    TECO_TABLE: 'テコガールのオーダー表',
    PLAY: '興味のある遊び',
    NOMINATE_GIRL: 'テコガールを指名する',
    NOMINATE_HINT: '※選ばなければフリーになります',
    START_TIME: '開始日時',
    ESTIMATED_AMOUNT: '目安金額',
    GAME_FEE: 'ゲーム代',
    ENTER_DETAIL: '詳細情報の入力へ',
    PAYMENT_WARNING:
      'アプリシステム利用手数料15%がかかりますが\n現金支払いの場合はアプリシステム利用手数料相当分を割引させていただきます。',
    LABEL_OPTIONS: 'セット数（1セット/60分）・テコガール数',
    OPTION_SET: 'セット数（1セット/60分）・',
    OPTION_PEOPLE: 'テコガール数',
    ABOUT_AUTO_EXTENSION: '※自動延長制となります',
    OPTION_AREA: '場所',
    DATE_WARNING: '過去時間を選択できません',
    END_DATE_ERROR: '終了時刻を開始時刻より小さくすることはできません',
    INPUT_ID: '名前またはIDを入力してテコガールを指名する ',
    INPUT_PLACEHOLDER: 'テコガールの名前またはIDを入力',
    INPUT_MALE_ID: '一緒に遊ぶ男性',
    INPUT_MALE_HINT: '名前またはIDを入力して一緒に遊ぶ男性を指名する',
    INPUT_MALE_PLACEHOLDER: '男性会員の名前またはIDを入力',
    PLAY_WITH_KID: 'この子と遊ぶ',
    CALL_BY_NAME: '指名して呼ぶ',
    GO_ON_TRIP: '旅行に行く',
    NOMINATED_GIRL: '指名テコガール',
    CONFIRM_YOUR_ORDER: '注文内容の確認へ',
    CONFIRM_MODAL_APPROVE: '本当に承認しますか？',
    CONFIRM_MODAL_APPROVE_STEP2: '本当に同意しますか？',
    CONFIRM_MODAL_APPROVE_DESC:
      '内容をご確認の上、問題なければ「はい」を押してください。',
    CONFIRM_MODAL_REJECT: '本当に拒否しますか？',
    CONFIRM_MODAL_REJECT_DESC: '拒否するとこの案件はキャンセルされます。',
    CONFIRM_INVITED_PROJECT_ORDER_STEP1: '案件内容を承認しますか？',
    CONFIRM_INVITED_PROJECT_ORDER_STEP2: 'お支払方法について同意しますか？',
    APPROVE_PROJECT_ORDER_STEP1: '承認する',
    APPROVE_PROJECT_ORDER_STEP2: '同意する',
    UPDATE_APPROVE_PROJECT_ORDER_STEP1: '確認しました',
    UPDATE_APPROVE_PROJECT_ORDER_STEP2: '同意しました',
    CONFIRM_REJECT_INVITED_PROJECT_ORDER: '案件招待を承認しますか？',
    APPROVE_PROJECT_ORDER: '承認する',
    REJECT_PROJECT_ORDER: '拒否する',
    UPDATE_APPROVE_PROJECT_ORDER: '承認しました',
    UPDATE_REJECT_PROJECT_ORDER: '拒否しました',
  },
  ORDER_DETAIL: {
    RECRUITMENT_DETAIL: '注文の詳細',
    PLAY: '遊び方の要望',
    MEETING_ADDRESS: '合流住所',
    ADDRESS: '住所...',
    ORDER_TYPE: '注文種希望',
    HOW_TO_PLAY: '遊び方',
    NUMBER_CUSTOMER: 'お客様の人数',
    NUMBER_MALE: '男性の人数',
    NUMBER_FEMALE: '女性の人数',
    NOTE_REQUEST: 'その他備考や要望',
    CALL_GIRL: 'テコガールを呼ぶ',
    CALL_HINT: '(確定まで数分程度のお時間を要します)',
    CALL_WARNING:
      '※遠方など入力した内容により、運営から確認のご連絡が入る場合がございます。',
    PREFIX_ADDRESS: '住所前半',
    PREFIX_ADDRESS_PLACEHOLDER: '例：東京都渋谷区渋谷',
    SUFFIX_ADDRESS: '住所後半',
    SUFFIX_ADDRESS_PLACEHOLDER: '例：1-2-3 渋谷ビル 101',
    CHOOSE_AREA: 'どちらのエリアに\n呼びますか?',
    AREA: 'エリア',
    AREA_DETAILS: 'エリア詳細',
    OTHERS: 'その他',
    ENTER_LOCATION: '場所を入力してください',
    LINE_INTEGRATION: '注文にはLINE連携してください',
  },
  SUMMARY_ORDER: {
    CONFIRM_ORDER: '注文確認',
    ORDER: '注文',
    ORDER_SUCCESS_MESSAGE: 'ご注文ありがとうございます！',
    ORDER_SUCCESS_HINT: '派遣まで少々お待ちください。',
    SALON_DERBY_FREE_MESSAGE:
      'この注文で tecoダービーのフリー予想に参加できます',
    SALON_DERBY_FREE_LINK: 'tecoダービーで予想する',
    ORDER_THANK: 'ご注文ありがとうございます！',
  },
  HOME_PAGE: {
    RECOMMEND: 'おすすめ',
    MEMBER_BOARD: 'サロン会員掲示板',
  },
  MODAL: {
    WARNING_18: 'あなたは18歳以上ですか？',
    WARNING_MESSAGE:
      '18歳未満の方はご遠慮ください。\n必ず利用規約を確認いただきご利用ください。',
    WARNING_REFRAIN: '遠慮ください。',
    CUSTOMER_HERE: 'お客様はこちら',
    OFFICE_WORKER: '内勤・エンジニア',
    GIRL_JOB: 'テコガールの求人',
    FRANCHISE_RECRUITMENT: 'フランチャイズ募集',
  },
  ORDER_METHOD: {
    AUTO_CALL: 'おまかせで呼ぶ',
    AUTO_BUTTON: '人数を決める',
    ELECTIVE_CALL: '指名して呼ぶ',
    CHOOSE_CAST: 'テコガールを選ぶ',
  },
  AUTO_CALL: {
    INVITE_QUESTION: '何人呼びますか？',
    ROYAL_VIP_INFO: 'キャストの中でも1％しかいない希少な最上級キャスト',
    ROYAL_VIP: 'ロイヤルVIP',
    VIP_INFO: '特選キャストの中でも10％しかいない特別なキャスト',
    VIP: 'VIP',
    PREMIUM: 'プレミアム',
    PREMIUM_INFO: '合格率10％の面接を通過した厳選キャスト',
  },
  MESSAGE: {
    MESSAGE_LIST: 'メッセージ一覧',
    ENTER_NAME: '名前を入力',
    INPUT_PLACEHOLDER: 'メッセージを入力...',
    QUESTION_PLACEHOLDER: '利用場所はどこがありますか？',
    QUESTIONS_TO_MANAGEMENT: '運営への質問はこちらから',
    START_MESSAGE: '個別のメッセージができます',
    IMAGE: '「画像」',
    VIDEO: '「動画」',
    FAKE_PREVIEW:
      '👮 tecoのご利用ガイド👮tecoへのご登録ありがとうございます。ご不明な点・お問い合わせは「メッセージ」より運営スタッフへお問い合わせください。',
    CANNOT_REPLY: `読むことしかできません。`,
    AUTOMATED_CHAT: '自動メッセージ受信用チャット',
    GIVE_A_GIFT: '$nameを贈りました',
    CREATE_GROUP_WITH_THIS_PERSON: 'この人と団体を組む',
  },
  CHAT: {
    ADD_GAME_MESSAGE: '追加するゲームを選んでください',
    ORDERED_GAME: '注文しているゲーム一覧',
    LIST_GAME: 'ゲーム一覧',
    ADD_GAME: 'ゲームを追加する',
    CANCEL_GAME_MESSAGE: '注文したゲームを取り消します。',
    ADD_FEMALE: 'テコガール追加',
    DISSOLUTION: '会計',
    ADD_TECO_GIRL: 'テコガールの追加',
    DISSOLUTION_LEVERAGE: '解散(終了)',
    RELEASE_LEVERAGE_GIRL_CONFIRM: ' 解散(終了)します。宜しいでしょうか。',
    RELEASE_LEVERAGE_GIRL: ' 解散する',
    RELEASE_TECO_GIRL: '会計',
    ADDITIONAL_ESTIMATED_AMOUNT: '追加目安金額',
    BUTTON_ADD_GIRL: 'テコガールを追加する',
    GAMES_TO_ORDER: '注文するゲーム',
    SELECT_TECO_GIRL: '注文するテコガールを選択する',
    SELECT_NOTE: '※選べばなければ全適用になります',
    GAME_ORDER: 'ゲーム注文',
    LIST_TECO_GIRL: 'テコガール一覧',
    MESSAGE_PROHIBITED_WARNING:
      '$wordは禁止ワードとなりますので、メッセージを送信できません。',
    GIVE_STAMPS_NOTE: 'テコガールに投げ銭スタンプを贈ることができます',
  },
  PAYMENT: {
    ADVANCE_PAYMENT: '前払い',
    PAYMENT_METHOD: 'お支払い方法',
    PAYMENT_SUCCESS: 'クレジットカード決済が完了しました',
    PAYMENT_CASH_SUCCESS: '現金決済を選択されました。',
    POINT_PAYMENT_SUCCESSFULLY: 'teco資産決済が完了しました。',
    CARD_NUMBER: 'カード番号',
    EXPIRATION_DATE: '有効期限',
    CARD_NAME: 'カード上の名前',
    SECURITY_CODE: 'セキュリティコード',
    BANK: '銀行振込\n(今すぐのお振込)',
    CASH: '現金',
    CARD: 'クレジットカード',
    POSTPAY: '後払い\n(後で銀行振込)',
    POSTPAY_ANNOUNCE: '※身分証と顔写真登録必須',
    CREDIT_CARD: 'クレカ',
    POINT_ASSET: 'teco資産',
    ADD_METHOD: '支払い方法を追加',
    NOTE: `※上記で選択したカードで決済エラーが発生した場合は、自動的に別の登録カードで決済されます。 カード情報を削除する場合は、削除したいカードを左にスワイプしてください。\n※プリペイドカードは登録できません。`,
    TO_PAYMENT: '支払いへ',
    CHOOSE_METHOD: 'お支払い方法を選択する',
    WAIT_MESSAGE: '決済方法についてメッセージしますのでお待ちください',
    CHOOSE_PAYMENT_METHOD_PLEASE: '支払い方法を選択してください',
    GO_TO_PAYMENT_PAGE: '決済ページはこちら',
    VISA: 'VisaとMaster \n とJCB',
    ENTER_AMOUNT: '決済金額を入力してください',
    REMAINING_BALANCE: '決済した後のお会計の残額：',
    CARD_REMAINING_BALANCE: '残額 (カード払い)：',
    MAKE_PAYMENT: '決済する',
    PAY_POINT_SUCCESS: '$amount円のteco資産決済を選択されました。',
    PAY_CASH_SUCCESS: '$amount円の現金決済を選択されました。',
    PAY_CARD_SUCCESS: '$amount円のクレジットカード決済が完了しました',
    POSTPAY_REQUEST_SUCCESS: '$amount円の後払い申請が完了しました',
    BANK_REQUEST_SUCCESS: '$amount円の銀行振込申請が完了しました',
    AMOUNT_SETTLED: 'で決済する金額',
    CARD_MAINTENANCE:
      '現在、カード決済はご利用いただけません。\nお支払いには teco資産をご利用いただけますので、\nぜひこの機会にご利用ください。',
  },
  RELEASE_GIRL: {
    RELEASE_AMOUNT: '会計金額',
    FREE_GIRL: '会計する',
    CHOOSE_GIRL: '会計するテコガールを選ぶ',
    NOTE_CHOOSE_GIRL: '※選ばなければ全会計になります',
    NUM_OF_SET: 'セット数（1セット/60分)',
    TOTAL_PRICE: 'セット料金',
    TOTAL: '合計',
    TOTAL_ABOVE: '上記の合計',
    DISCOUNT: '割引額',
    GAME_DISCOUNT: 'ゲーム代割引額',
    TOTAL_CASH: '合計 (現金払い)',
    TOTAL_CARD: '合計 (カード払い)',
    TOTAL_CASH_NO_DISCOUNT: '合計 (現金払い)',
    TOTAL_CARD_NO_DISCOUNT: '合計 (カード払い)',
    NOMINATION_FEE: '指名料金',
    HANDLING_FEE: '（アプリシステム利用手数料15%）',
    PRE_PAID: '前払い額 (カード払い)',
    SUB_TOTAL: '小計',
    PROJECT_DISCOUNT: '会計総額から割引額',
    PAYMENT_CONFIRM: '支払い確認',
    GAME_PAYMENT_NOTICE:
      'FCエリアではテコガール一人当たりのゲーム代の上限金額が$price万円になるので、今回のゲーム代は$price万円になります。',
  },
  REVIEW_GIRL: {
    QUESTIONNAIRE: 'テコガールへの\nアンケート',
    SEND: '送信する',
    TEXT_COMMENT: '自由記述コメント',
    RATING: '5段階評価',
    REVIEW_SUCCESS: '成功のレビュー',
  },
  PWA_GUIDE: {
    IMAGE_ALT_IPHONE_SAFARI:
      'iPhone（Safari）でtecoをホーム画面に追加する3ステップ',
    IMAGE_ALT_IPHONE_CHROME:
      'iPhone（Chrome）でtecoをホーム画面に追加する3ステップ',
    IMAGE_ALT_ANDROID: 'Androidでtecoをホーム画面に追加する3ステップ',
  },
  GAME_PAGE: {
    WHAT_IS_TECO: 'tecoとは',
    GROUP_LEVERAGE_GAME: '団体テコ専用ゲーム',
    NORMAL_GAME: '通常のゲーム',
    NOTE_LEVERAGE_GAME:
      '【団体テコ専用ゲームで明朗会計に】\n①〝王様ゲーム〟が入った場合は以降のゲームや命令に追加料金は一切かかりません。\n②〝王様のコイン〟〝王様のアプリ〟〝王様ゲーム〟は全てのゲームと類する命令を行えます。\n③お客様とテコガールでほかのゲームや金額を自由にお決めいただいてもOKです。\n④たくさんゲームをする予定であればはじめに“王様のアプリ”や“王様ゲーム”をいれるほうがお得になる場合がございます。また“王様ゲーム”は１：１の個テコではご利用いただけません。\n⑤“王様のアプリ”から“王様ゲーム”に切り替える場合は差額の2万円をお支払いいただければスライド可能となっています',
    START_APP: 'アプリを起動',
    INDIVIDUAL_LEVER: '個テコ専用ゲーム',
    USEFUL_TIMER: '便利なタイマー',
    ABOUT_KING_APP: '-  王様のアプリについて-',
    KING_APP_STEP_1:
      '①王様のアプリ には軽い命令からハード♡な命令まで多種多様にはいっています',
    KING_APP_STEP_2: '②１：１の個テコでもかなり楽しめるものになっていまいます',
    KING_APP_STEP_3:
      '③王様のアプリ を入れた場合はそれ以上の追加料金はかかりません',
    GAME_SINGLE_NOTE: 'このゲームは個テコ専用ゲームです',
  },
  POST: {
    POST: 'ポストする',
    POST_STATUS_LABEL: 'ポスト',
    CONTENT_PLACEHOLDER: 'いまから来れる人メッセージください！',
    SUCCESS: '投稿に成功しました',
    FOLLOW_POST_NOTE: 'フォローすると閲覧できます',
    FOLLOW_AND_BROWSE: 'フォローして閲覧する',
    PREMIUM_POST_NOTE:
      '※動画内容はtecoのサービス内容と紐づくものではございません\n※映像送信型性風俗特殊許可取得済み',
  },
  PAYMENT_DEFERRAL_REQUEST: {
    POSTPAY: '後払い',
    BANK: '銀行振込',
    TITLE: '$type申請',
    POSTPAY_EXPIRE_DATE: '翌日',
    BANK_EXPIRE_DATE: '当日',
    OPEN_POST_PAYMENT_PAGE: '後払い申請ページへ進む',
    OPEN_BANK_PAYMENT_PAGE: '銀行振込申請ページへ進む',
    ANNOUNCE_TITLE: '‼️ご利用前に必ずご確認ください‼️',
    ANNOUNCE_DESCRIPTION: [
      {
        HEAD: '$index. 支払い期日：$expireDate（23:59 まで）',
        DESC: [
          '$typeが承認された日の $expireDate 23:59 までに、画面でご案内する銀行口座へお振り込みください。（※期日を過ぎた場合のペナルティあり）',
        ],
      },
      {
        HEAD: '$index. 本人確認書類の提出必須',
        DESC: [
          '顔写真付きの公的身分証（運転免許証・マイナンバーカード等）と、身分証を持ったセルフィーの 2 枚を、その場で撮影してアップロードしてください。',
          '不鮮明・加工・別人の画像は承認されません。再提出が必要となる場合があります。',
        ],
      },
      {
        HEAD: '$index. SMSによる電話番号確認',
        DESC: [
          '申請後、入力された連絡用携帯番号へ当社スタッフから本人確認のメッセージをお送りします。内容をご確認のうえ、必ずご返信ください。',
        ],
      },
      {
        HEAD: '$index. 審査結果による利用可否',
        DESC: [
          '提出内容に不備がある場合や当社審査基準を満たさない場合、$typeをお断りすることがあります。',
        ],
      },
    ],
    ANNOUNCE_AGREE_NOTE:
      '※上記に同意いただける場合のみ、$titleを進めてください。',
    ID_CAPTURE_TITLE: '身分証撮影',
    ID_CAPTURE: '身分証を撮影する',
    ID_BACK_CAPTURE_TITLE: '身分証裏面撮影',
    ID_BACK_CAPTURE: '身分証裏面を撮影する',
    ID_SELFIE_TITLE: '本人確認撮影',
    ID_SELFIE: '顔と身分証を一緒に撮影する',
    PHONE_TITLE: '連絡用の携帯番号',
    POSTPAY_SUCCESS_MESSAGE:
      '後払い申請が完了しました。確認のSMSをスタッフよりお送りしますので少々お待ちください。',
    BANK_SUCCESS_MESSAGE:
      '銀行振込の申請が完了しました。確認のメッセージをスタッフより送信しますので少々お待ちください。',
    SEND: '申請する',
  },
  GIFT: {
    NOTE: `※スタンプ送付後はいかなる理由があっても、 キャンセル・返金は一切できません。`,
    GIVE_GIFT: '$giftを贈る',
    PAYMENT_SUCCESS: '決済成功',
    PAYMENT_FAIL: '決済失敗',
    CONTINUE_PAY: '残額を決済する',
    CREDIT_REGISTRATION: 'クレジットカード決済',
    WARNING_MESSAGE: '現在のゲストランクでは送付できません',
    PAYMENT_PROCESSING_MESSAGE: '恐れ入りますが残額の決済をお願いいたします。',
    SUPPORT_PAYMENT: '※銀行振込デポジット(現金払い)機能は近々対応予定です',
    CHARGE_POINT: 'teco\n資産購入',
  },
  POINTS: {
    TRANSFER_SCHEDULE_INFO: '振込予定情報',
    TITLE_OF_BUY_POINT: 'teco資産を購入する',
    POINT_HISTORY_TITLE: 'teco資産購入履歴',
    BANK_TRANSFER: '銀行振込',
    CREDIT_CARD: 'クレジットカード',
    CASH_HANDOVER: '現金手渡し',
    REQUEST_PENDING: '承認待ち',
    REQUEST_APPROVED: '承認済み',
    REQUEST_REJECTED: '却下',
    REQUEST_CANCELED: '取消',
    OWNED_TECO_ASSETS: '所持teco資産',
    USAGE_HISTORY: '履歴',
    EXPIRED_POINTS: 'teco資産の有効期限は購入から179日です',
    PLEASE_TRANSFER_TO_BANK_ACCOUNT: '銀行口座にお振込をお願いいたします',
    BANK_ACCOUNT: '振込先銀行口座',
    FINANCIAL_INSTITUTION_NAME: '金融機関名',
    BRANCH_NAME: '支店名',
    ACCOUNT_TYPE: '口座種類',
    ACCOUNT_NUMBER: '口座番号',
    ACCOUNT_NAME: '口座名義',
    POINT_TERMS:
      'teco資産チャージは振込から通常24時間以内に反映されます。\n 銀行の営業時間外などで反映が遅れることもございます。\n また、ご購入いただいたteco資産は、いかなる場合でも返還いたしかねます。※1T=1円',
    ENTER_TRANSFER_NAME_AND_MONEY: '振込名義と金額を入力してください',
    TRANSFER_NAME: '振込名義(全角カナ)',
    TRANSFER_OF_MONEY: '振込金額',
    TECO_ASSETS_TO_BE_REFLECTED: '反映予定teco資産',
    PLEASE_PAY_BANK_TRANSER: '振込手数料はご自身にてご負担ください。',
    RATE: '1T=1円となります。',
    NOTES: '注意事項',
    NO_REFUND_WITH_ANY_REASON:
      '理由のいかんを問わずお振込いただいた金額の払い戻しやteco資産の換金はいたしません。',
    APPLY: '申請する',
    TRANSFER_APPLICATION: '振込申請',
    TECO_ASSET_CHARGE: 'teco資産チャージ',
    RELEASE: 'で解放',
    GUEST_RANK: 'ゲストランク',
    PURCHASE_CONFIRMATION: '購入確認',
    CONTENT_OF_PURCHASE_POINTS:
      '$priceで$amountを購入します。※購入後のキャンセル・返金は一切できません',
    BUY_NOW: '購入する',
    PURCHASED_TECO_ASSETS: 'teco資産を購入しました。',
    UNCHARGED: '未チャージ',
    CHARGED: 'チャージ済み',
    PLEASE_ENTER_KATAKANA: '全角カナで入力してください',
    SKIP: 'スキップする',
  },
  ERROR: {
    LIMIT_FILE: `画像またはビデオを$numberつ以上アップロードできません！`,
    LIMIT_SIZE: '写真は$sizeを超えてはなりません',
    LIMIT_NUMBER: '価格は$number円を超えることはできません',
    MINIUM_AMOUNT: '最少金額は$amount円です。',
    NOT_ENOUGH_POINT: 'teco資産が不足しています。',
    MGM_CHANNEL_NOT_FOUND: '管理者チャネルが取得できませんでした。',
  },
  INTRODUCING: {
    INTRODUCING_FRIEND: 'お友達紹介',
    STEP1: 'ページ下の「招待のURL」をコピーし、友達に共有する',
    STEP2:
      '「招待のURL」からお友達がtecoに登録すると、お友達へ10,000円分のteco資産をプレゼント',
    STEP3: 'お友達がtecoを初利用であなたに10,000円分のteco資産をプレゼント',
    TECO_ASSET_NOTE:
      '※teco資産はtecoのご注文などでご利用いただけます。\n※teco資産の有効期限は179日です。',
    INVITAION_URL: '招待のURL',
    REGISTER_NOTE:
      '会員登録はホーム画面にアプリをインストールする必要があります。\nホーム画面にインストールしたアプリから会員登録はできます。',
  },
  RANKING: {
    ALL_AREA: '全国',
    RATING_RANKING: 'ランキング',
    GROUP_OVERALL_RATING: '団体 総合評価',
    INDIVIDUAL_OVERALL_RATING: '個テコ 総合評価',
    OVERALL_RATING: '総合評価',
    NUM_SET_SOLO_PROJECT: '獲得売上',
    SETTING_COUNT: '獲得組数',
    TIME_PERIOD: {
      YESTERDAY: '前日',
      LAST_WEEK: '先週',
      LAST_MONTH: '先月',
      RECENT_7_DAYS: '直近7日間',
      RECENT_30_DAYS: '直近30日間',
    },
  },
  RECEIPT: {
    TITLE: '領 収 書',
    NO_PREFIX: 'No.',
    HONORIFIC: '様',
    CURRENCY: '¥',
    PURPOSE: '但　$value',
    PURPOSE_CASH: 'ご飲食代　現金にて',
    PURPOSE_BANK: 'ご飲食代　銀行振込にて',
    PURPOSE_CARD: 'ご飲食代　カード決済にて',
    PURPOSE_POINT: 'ご飲食代　アプリ内ポイントにて',
    CONFIRMATION: '上記正に領収いたしました',
    DOWNLOAD: '領収書をダウンロード',
    COMPANY_ADDRESS: '東京都千代田区神田和泉町2-17 脇田ビル4階',
    COMPANY_NAME: '株式会社tk(収納代行会社)',
    COMPANY_ADDRESS_FC: '神奈川県横浜市　泉区和泉ヶ丘3-23-11',
    COMPANY_NAME_FC: 'K2 合同会社(収納代行会社)',
  },
  LINE: {
    ERROR: {
      TITLE: '処理に失敗しました',
      CODES: {
        INVALID_REQUEST:
          'リクエストに問題があります。認可URLのクエリパラメータを確認してください。',
        ACCESS_DENIED:
          'ユーザーが同意画面でキャンセルし、アプリへのアクセス権の付与を拒否しました。',
        UNSUPPORTED_RESPONSE_TYPE:
          'LINEログインではcodeのみをサポートしています。',
        INVALID_SCOPE: 'scopeクエリパラメータの値に問題があります。',
        SERVER_ERROR: 'LINEログインサーバーで予期しないエラーが発生しました。',
        LOGIN_REQUIRED:
          '自動ログインが動作しない、または未ログインの状態です。',
        INTERACTION_REQUIRED: '端末で自動ログインが動作しませんでした。',
      },
    },
    UNKWOWN: '男性ユーザー',
    CONFIRM_LOGIN: 'LINEログインするとつぶやき投稿できます',
    CONFIRM_LOGIN_TITLE: 'LINEで派遣状況をお知らせ！',
    LOGIN: 'LINEログイン',
    ADD_FRIEND_WARNING:
      '公式アカウントが変更されました。\n新しく友達追加をしてください。',
    FRIENDS: '友龙ち油加',
    ADD_FRIEND: '友だち追加',
    ADD_FRIEND_LINE: 'アカウント変更のため、新しいLINEの追加をお願いします',
    LOADING: {
      TITLE: 'LINE連携処理中...',
      DESCRIPTION: 'しばらくお待ちください',
    },
    ACTIONS: {
      BACK: '戻る',
      RETRY: '再試行',
    },
    MANAGEMENT: {
      MALE: 'お客さん用LINEアカウント',
      FEMALE: 'テコガール用LINEアカウント',
    },
    REQUIRE_ACTIVATE_LINE: 'REQUIRE_ACTIVATE_LINE',
    ACTIVATE_LINE: 'ACTIVATE_LINE',
    ADD_FRIEND_PAGE: {
      TITLE: '友だち追加が必要です',
      DESCRIPTION:
        'LINEで公式アカウントを友だち追加すると、メッセージ通知などが受け取れるようになります。',
      ACTIONS: {
        OPEN_LINE: 'LINEで友だち追加する',
        CONFIRM: '友達追加しました。',
        BACK: '戻る',
      },
      SUCCESS: 'ありがとうございます。\n友だち追加が確認できました。',
      ERRORS: {
        NOT_FRIEND_YET:
          '友だち追加が確認できませんでした。\nもう一度お試しください。',
        BASIC_ID_NOT_FOUND:
          'basicId が見つかりません。\n最初からやり直してください。',
      },
    },
  },
  LIST_MALE: {
    TITLE: '男性一覧',
    CREATE_PROJECT: '案件を作成する',
    START_DM: 'メッセージする',
    CREATE_SALON_GROUP_CHAT: 'グループチャット作成',
    CREATE_WITH_SELECTED_MEMBERS: '選択した男性で作成',
    CANCEL_GROUP_CHAT: 'キャンセル',
    SELECT_AT_LEAST_ONE_MEMBER: '1人以上選択してください',
    SALON_REQUIRED_TITLE: 'teco サロン会員限定',
    SALON_REQUIRED_MESSAGE: 'tecoサロンに入会後利用できます',
    FILTER_PLACEHOLDER: '検索条件',
    FILTER_TITLE: '絞り込み検索',
    FILTER: {
      AREA: 'エリア',
      GUEST_RANK: 'ゲストランク',
      SALON_MEMBER: 'サロン会員',
    },
  },
  SALON_INQUIRY_BANNER: {
    ALT: 'テコサロン入会問い合わせ',
  },
  CHAT_BANNER: {
    ALT: 'テコサロン入会のご案内',
  },
};

export default TEXT_STRING;
